import React from 'react';
import { useTimer } from 'react-timer-hook';


export default function MyTimer({ expiryTimestamp, onExpired }) {
  const {
    //totalSeconds,
    seconds,
    minutes,
    // hours,
    // days,
    // isRunning,
    // start,
    // pause,
    // resume,
    // restart,
  } = useTimer({ expiryTimestamp, onExpire: () => onExpired() });

  const format = (val) => {
    if(val < 10)
      return "0" + val;
    else
     return val;
  }
  return (<span style={{textAlign: 'center'}}>{minutes}:{format(seconds)}</span>);
}